export class ViewApplicationProfessionalBodiesWamsConstants {
    static STEP_TITLE = "Professional bodies";
    static MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_LABEL = "Are the implementing agent's details required?";
    static MARK_ENGINEER_AS_NOT_APPLICABLE_LABEL = "Are the civil engineer's details required?";
    static MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markEngineerAsNotApplicable";
    static MARK_CONTRACTOR_AS_NOT_APPLICABLE_LABEL = "Are the contractor's details required?";
    static IMPLEMENTING_AGENT_LABEL = "Implementing agent / consultant";
    static ENGINEER_LABEL = "Civil engineer";
    static RESPONSIBLE_CONTRACTOR_LABEL = "Responsible contractor";
    static IMPLEMENTING_AGENT_FORM_CONTROL_NAME = "implementingAgentRecipient";
    static ENGINEER_FORM_CONTROL_NAME = "engineerRecipients";
    static RESPONSIBLE_CONTRACTOR_FORM_CONTROL_NAME = "responsibleContractorRecipient";
    static IMPLEMENTING_AGENT_DETAILS_HEADER = "Implementing agent details";
    static ENGINEER_DETAILS_HEADER = "Engineer details";
    static CONTRACTOR_DETAILS_HEADER = "Contractor details";
    static PROFESSIONAL_BODIES_FORM_CONTROL = "professionalBodiesForm";
}
